import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { ENABLE_LOGGING } from 'utils/constants'
import { getActionName } from './utils'
import { isProd } from 'config/constants'

export type CommonPoolStoreType = {
  selectedVault: { label: string; value: string }
  setSelectedVault: (
    selectedVault: CommonPoolStoreType['selectedVault'],
  ) => void
}
const STORE_NAME = 'common-pool'

const commonPoolStore = create<CommonPoolStoreType>()(
  devtools(
    (set) => ({
      selectedVault: {
        label: 'scUSD',
        value: isProd
          ? '0x0bfFb867472cdaE11D0A10020Ab9a9d9Fdf6193b'
          : '0x8662a6c0821B2b5c6e71cf97B2C66fA7D06d8B75',
      },
      setSelectedVault(selectedVault) {
        set(
          { selectedVault },
          false,
          getActionName(STORE_NAME, 'selectedVault'),
        )
      },
    }),
    { enabled: ENABLE_LOGGING, name: 'common-pool' },
  ),
)

export default commonPoolStore
